var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-parsing-link"},[_c('section',{staticClass:"loading-rtc"},[_c('div',{staticClass:"loading-animation"}),_c('span',[_vm._v(_vm._s(_vm.$t('home.ResolvingInviteLink'))+"...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }